import React from "react";

export function PageHeader({ title, subtitle, right }) {
  return (
    <div className="flex items-center justify-between mb-4">
      <div>
        <h1 className="text-[20px] font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="text-[12px] mt-0.5" style={{ color: "var(--text-muted)" }}>{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function ScoreBreakdown({ analysis }) {
  const comps = analysis?.components || [];
  return (
    <div className="ym-panel p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-[13px] font-bold">Rincian Skor</h3>
        <span className="text-[11px]" style={{ color: "var(--text-muted)" }}>Dapat dijelaskan · teknikal live</span>
      </div>
      <div className="space-y-2.5">
        {comps.map((c) => {
          const long = c.long, short = c.short, w = c.weight;
          return (
            <div key={c.key} className="rounded-lg p-2.5" style={{ background: "var(--panel-2)", border: "1px solid var(--border)" }}>
              <div className="flex items-center justify-between mb-1.5">
                <span className="text-[12px] font-semibold">{c.label} <span className="text-[10px]" style={{ color: "var(--text-dim)" }}>·{w}pts</span></span>
                <div className="flex items-center gap-2 text-[11px] tabnum">
                  <span style={{ color: "var(--green)" }}>L {long}</span>
                  <span style={{ color: "var(--red)" }}>S {short}</span>
                </div>
              </div>
              <div className="flex h-1.5 rounded-full overflow-hidden mb-1.5" style={{ background: "#0000004d" }}>
                <div style={{ width: `${(long / w) * 50}%`, background: "var(--green)" }} />
                <div style={{ width: `${(short / w) * 50}%`, background: "var(--red)" }} />
              </div>
              <p className="text-[10.5px] leading-snug" style={{ color: "var(--text-muted)" }}>{c.reason}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export function StatCard({ label, value, sub, color }) {
  return (
    <div className="ym-card p-4">
      <div className="text-[10px] font-semibold tracking-wide mb-1" style={{ color: "var(--text-dim)" }}>{label.toUpperCase()}</div>
      <div className="text-[22px] font-extrabold tabnum" style={{ color: color || "var(--text)" }}>{value}</div>
      {sub && <div className="text-[11px] mt-0.5" style={{ color: "var(--text-muted)" }}>{sub}</div>}
    </div>
  );
}

export function DemoBadge() {
  return <span className="pill" style={{ fontSize: 9, padding: "1px 7px", color: "var(--amber)", background: "rgba(245,158,11,.12)", borderColor: "rgba(245,158,11,.3)" }}>DEMO</span>;
}

export function LiveBadge() {
  return <span className="pill" style={{ fontSize: 9, padding: "1px 7px", color: "var(--green)", background: "rgba(34,197,94,.12)", borderColor: "rgba(34,197,94,.3)" }}>LIVE</span>;
}
